import React from "react";
import MainButton from "../common/buttons/mainButton/MainButton";
import { Styles } from "./styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import environment from "../../environment";
import { successToaster } from "../../helpers/toasterConfiguration";

const Course = ({
  courseImage,
  courseName,
  coursePrice,
  currency,
  courseDecription,
  studentCount,
  sessionsCount,
  Type,
  slug,
  rate,
  fullNameEn,
  fullNameAr,
  shareLink,
}) => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";
  const navigate = useNavigate();
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  const _token = environment.TOKEN_KEY;
  const isLogin = localStorage.getItem(_token);

  // fill stars
  // function Rating({ rate }) {
  //   const stars = [];
  //   for (let i = 1; i <= 5; i++) {
  //     if (i <= rate) {
  //       stars.push(<i key={i} className="fa-solid fa-star"></i>);
  //     } else if (i === Math.ceil(rate) && rate % 1 !== 0) {
  //       stars.push(<i key={i} className="fa-regular fa-star-half-stroke"></i>);
  //     } else {
  //       stars.push(<i key={i} className="fa-regular fa-star"></i>);
  //     }
  //   }
  //   return <div className={isAr ? "stars" : "stars stars-en"}>{stars}</div>;
  // }

  const copyToClipBoard = (text) => {
    navigator.clipboard.writeText(text);
    successToaster(t("copied_success"));
  };

  return (
    <Styles>
      <div
        className="course"
        onClick={() => {
          navigate(
            Type === "Live"
              ? `/course-details/${slug}`
              : `/course-details/recorded/${slug}`
          );
        }}
      >
        <div className="course-img">
          <img src={courseImage} alt="course image" />
        </div>
        <div className="course-content">
          {isLogin &&
            (coursePrice !== 0 ? (
              <div className="course-price">
                <div className="price">
                  {coursePrice?.toLocaleString("en-US")} {currency}
                </div>
              </div>
            ) : (
              <div className="course-price">
                <div className="price">{t("free")}</div>
              </div>
            ))}
          <div className="course-name">{courseName}</div>
          <div className="course-trainer">
            {t("home.trainers.coach")} : {isAr ? fullNameAr : fullNameEn}
          </div>
          <div className="course-info">
            <span className="course-decription">{courseDecription}</span>
            {/* <div className="course-buttons">
              <span>
                <div
                  className=""
                  onClick={() => {
                    copyToClipBoard(
                      `${window.location.origin}/course-details/${slug}`
                    );
                  }}
                >
                  <i className="fa-solid fa-paper-plane"></i>
                </div>
              </span>
            </div> */}
          </div>
          <div className="course-statistics">
            <div className="student">
              <svg
                id="user"
                xmlns="http://www.w3.org/2000/svg"
                width="7.894"
                height="11.841"
                viewBox="0 0 7.894 11.841"
              >
                <path
                  id="Path_1384"
                  data-name="Path 1384"
                  d="M13.262,5.631A2.631,2.631,0,1,1,10.631,3,2.631,2.631,0,0,1,13.262,5.631Zm-1.316,0a1.316,1.316,0,1,1-1.316-1.316A1.316,1.316,0,0,1,11.947,5.631Z"
                  transform="translate(-6.684 -3)"
                  fillRule="evenodd"
                />
                <path
                  id="Path_1385"
                  data-name="Path 1385"
                  d="M12.578,13.973a.658.658,0,0,0-.658-.658H7.973a.658.658,0,0,0-.658.658V17.92H6V13.973A1.973,1.973,0,0,1,7.973,12H11.92a1.973,1.973,0,0,1,1.973,1.973V17.92H12.578Z"
                  transform="translate(-6 -6.08)"
                />
              </svg>
              {studentCount}{" "}
              {Resource?.student ? Resource?.student : t("courses.student")}
            </div>
            <div className="sessions">
              {sessionsCount}{" "}
              {Resource?.session ? Resource?.session : t("courses.session")}
              <svg
                id="readme"
                xmlns="http://www.w3.org/2000/svg"
                width="13.011"
                height="10.054"
                viewBox="0 0 13.011 10.054"
              >
                <path
                  id="readme-2"
                  data-name="readme"
                  d="M2.774,4.683H5.731A1.183,1.183,0,0,1,6.914,5.866v5.323a.591.591,0,0,1-.591.591H2.774a.591.591,0,0,1-.591-.591V5.274A.591.591,0,0,1,2.774,4.683Zm5.914,8.28a1.772,1.772,0,0,1-.591-.1v.1a.591.591,0,1,1-1.183,0v-.1a1.772,1.772,0,0,1-.591.1H2.774A1.774,1.774,0,0,1,1,11.189V5.274A1.774,1.774,0,0,1,2.774,3.5H5.731a2.36,2.36,0,0,1,1.774.8A2.36,2.36,0,0,1,9.28,3.5h2.957a1.774,1.774,0,0,1,1.774,1.774v5.914a1.774,1.774,0,0,1-1.774,1.774ZM8.1,5.866v5.323a.591.591,0,0,0,.591.591h3.549a.591.591,0,0,0,.591-.591V5.274a.591.591,0,0,0-.591-.591H9.28A1.183,1.183,0,0,0,8.1,5.866Zm-4.731,0H5.731V7.049H3.366Zm5.914,0h2.366V7.049H9.28ZM11.646,7.64H9.28V8.823h2.366Zm-8.28,0H5.731V8.823H3.366Zm8.28,1.774H9.28V10.6h2.366Zm-8.28,0H5.731V10.6H3.366Z"
                  transform="translate(-1 -3.5)"
                  fill="#6f2877"
                  fillRule="evenodd"
                />
              </svg>
            </div>
          </div>
          <div className="course-details">
            <Link
              to={
                Type === "Live"
                  ? `/course-details/${slug}`
                  : `/course-details/recorded/${slug}`
              }
            >
              <MainButton
                buttonText={
                  Resource?.details ? Resource?.details : t("courses.details")
                }
              />
            </Link>
            {rate ? (
              <div className={isAr ? "rates" : "rates rates-en"}>
                <div className={isAr ? "stars" : "stars stars-en"}>
                  {[1, 2, 3, 4, 5].map((item, index) =>
                    item <= rate ? (
                      <i key={item} className="fa-solid fa-star"></i>
                    ) : item === Math.ceil(rate) && rate % 1 !== 0 ? (
                      <i
                        key={item}
                        className="fa-regular fa-star-half-stroke"
                      ></i>
                    ) : (
                      <i key={item} className="fa-regular fa-star"></i>
                    )
                  )}
                </div>
                {/* )} */}
                {rate}
              </div>
            ) : (
              <div className={isAr ? "rates" : "rates rates-en"}>
                <div className={isAr ? "stars" : "stars stars-en"}>
                  <i className="fa-regular fa-star"></i>
                  <i className="fa-regular fa-star"></i>
                  <i className="fa-regular fa-star"></i>
                  <i className="fa-regular fa-star"></i>
                  <i className="fa-regular fa-star"></i>
                </div>
                {rate}
              </div>
            )}
          </div>
        </div>
        <div
          className={`floating-btn ${Type}`}
          //  style={isAr ? {left:'-15%'}:{right:'-15%',left:'auto'}}
        >
          {Type !== "Live" && (
            <>
              {t("courses.recorded")} <i className="fa-solid fa-play"></i>
            </>
          )}
          {Type == "Live" && (
            <>
              {t("courses.live")} <i className="fa-solid fa-circle"></i>
            </>
          )}
        </div>
      </div>
    </Styles>
  );
};

export default Course;
